import { render, staticRenderFns } from "./ImportAggregateCosts.vue?vue&type=template&id=72d1ac15&scoped=true&"
import script from "./ImportAggregateCosts.vue?vue&type=script&lang=js&"
export * from "./ImportAggregateCosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d1ac15",
  null
  
)

export default component.exports